export default __webpack_public_path__ + "static/media/welpentreffen_15.ad2fe86e.jpg";